import React, { useState } from "react";
import styles from "../styles/confirmationModal.module.css";

const ConfirmationModal = ({
  title = "Confirm Action",
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
  additionalContent,

  isPrompt = false,
  promptPlaceholder = "",
}) => {
  const [inputValue, setInputValue] = useState("");

  const handleConfirm = () => {
    if (isPrompt) {
      onConfirm(inputValue);
    } else {
      onConfirm();
    }
  };

  const handleContentClick = (e) => {
    e.stopPropagation();
  };

  return (
    <div className={styles.modalOverlay} onClick={onCancel}>
      <div className={styles.modalContent} onClick={handleContentClick}>
        <h3 className={styles.modalTitle}>{title}</h3>
        <p className={styles.modalMessage}>{message}</p>

        {isPrompt && (
          <input
            type="text"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            className={styles.promptInput}
            placeholder={promptPlaceholder}
            autoFocus
          />
        )}

        {additionalContent && (
          <div className={styles.additionalContent}>{additionalContent}</div>
        )}

        <div className={styles.buttonContainer}>
          <button
            onClick={onCancel}
            className={`${styles.modalButton} ${styles.cancelButton}`}
          >
            {cancelText}
          </button>
          <button
            onClick={handleConfirm}
            className={`${styles.modalButton} ${styles.confirmButton}`}
            disabled={isPrompt && !inputValue.trim()}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
